import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const dividerVariants = tv({
  base: 'flex flex-col w-full h-fit justify-between items-center gap-y-3',
});

export type DividerProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof dividerVariants> & {
    isFluid?: boolean;
    label: string;
  };

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <section
        className={cn(
          dividerVariants({
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <div
          className="flex w-full items-center justify-center gap-5 bg-white"
          data-dd-privacy="allow"
        >
          <div className="h-[1px] w-full bg-gray-300" />
          <h1 className="title-4 font-semibold text-inherit">{label}</h1>
          <div className="h-[1px] w-full bg-gray-300" />
        </div>
      </section>
    );
  },
);

Divider.displayName = 'Divider';
